import { useState } from "react";
import { Search, Cog, Clock, ChevronDown, Check } from "lucide-react";
import { DATE_OPTIONS } from "./logFormatters";

interface LogFiltersProps {
  searchQuery: string;
  onSearchChange: (value: string) => void;
  systemLogs: boolean;
  onToggleSystemLogs: () => void;
  dateFilter: string;
  onDateFilterChange: (id: string) => void;
}

/** Search box + system-logs toggle + date-range dropdown. */
const LogFilters = ({
  searchQuery,
  onSearchChange,
  systemLogs,
  onToggleSystemLogs,
  dateFilter,
  onDateFilterChange,
}: LogFiltersProps) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const selectedDate = DATE_OPTIONS.find((o) => o.id === dateFilter);

  return (
    <div className="card border rounded-3 p-2 mb-4">
      <div className="d-flex align-items-center gap-2">
        <div className="position-relative flex-grow-1">
          <Search
            size={16}
            className="position-absolute text-secondary"
            style={{ left: 12, top: "50%", transform: "translateY(-50%)" }}
          />
          <input
            type="text"
            className="form-control form-control-sm bg-light border ps-5"
            placeholder="Search logs by action, user, or details..."
            value={searchQuery}
            onChange={(e) => onSearchChange(e.target.value)}
          />
        </div>

        {/* System logs toggle — sends system:true and resets to page 1 */}
        <button
          className={`btn btn-sm d-flex align-items-center gap-2 ${
            systemLogs ? "btn-primary" : "btn-outline-secondary"
          }`}
          onClick={onToggleSystemLogs}
          title="Show system-generated logs"
        >
          <Cog size={14} />
          <span>System logs</span>
        </button>

        <div className="position-relative">
          <button
            className={`btn btn-sm d-flex align-items-center gap-2 ${
              dropdownOpen ? "btn-primary" : "btn-outline-secondary"
            }`}
            onClick={() => setDropdownOpen((o) => !o)}
            onBlur={() => setTimeout(() => setDropdownOpen(false), 150)}
          >
            <Clock size={14} />
            <span>{selectedDate?.label}</span>
            <ChevronDown size={14} />
          </button>
          {dropdownOpen && (
            <div
              className="position-absolute end-0 mt-1 bg-white border rounded-3 shadow-sm py-1"
              style={{ width: 180, zIndex: 20 }}
            >
              {DATE_OPTIONS.map((opt) => (
                <button
                  key={opt.id}
                  className={`btn btn-sm w-100 text-start d-flex align-items-center justify-content-between px-3 ${
                    dateFilter === opt.id ? "text-primary fw-medium" : ""
                  }`}
                  onMouseDown={() => {
                    onDateFilterChange(opt.id);
                    setDropdownOpen(false);
                  }}
                >
                  <span>{opt.label}</span>
                  {dateFilter === opt.id && <Check size={14} />}
                </button>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default LogFilters;
